import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { filter } from 'rxjs/operators';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { KEYS } from 'src/app/shared/constants/keys';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';  
import * as _ from 'underscore';

@Component({
    selector: 'cmp-bread-crumbs',
    templateUrl: './bread-crumbs.component.html',
    styleUrls: ['./bread-crumbs.component.css'],
    standalone: false
})
export class BreadcrumbsComponent {

  selectedUrl=new FormControl('');
               
  moduleName:string;
  breadcrumbs: Array<breadModel>; public Title: string;
  @Input() public homeIcon = 'fa fa-home';
  constructor(private router: Router, private route: ActivatedRoute,
              private logger:NGXLogger, private activatedRoute:ActivatedRoute) {
    router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbs = [];
        let currentRoute = this.route.root,
          url = '';
        let tempBreadcrumb: string;
        do {
          const childrenRoutes = currentRoute.children;
          currentRoute = null;
          childrenRoutes.forEach(routes => {
            if (routes.outlet === 'primary') {
              const routeSnapshot = routes.snapshot;
              if(routeSnapshot.url.length){
                url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
              }
              if (routes.snapshot.data.title !== undefined) {
                if (tempBreadcrumb !== routes.snapshot.data.title) {
                  this.breadcrumbs.push({
                    Label: routes.snapshot.data.title,
                    Url: url
                  });
                }
                tempBreadcrumb = routes.snapshot.data.title;
                this.Title = tempBreadcrumb;
              }
              currentRoute = routes;
            }
          });
        } while (currentRoute);
      });
  }

  onChange(event:any){
    this.logger.info('Selected URL Value',this.selectedUrl.value);
    this.router.navigate([this.selectedUrl.value]);
  }

  disableCondition(moduleName:string){
    var permissionJson = JSON.parse(localStorage.getItem(KEYS.PERMISSION_DATA));
    let permissionKeys = [];
    for (var value in permissionJson) {
      permissionKeys.push(value);
    }
    return permissionKeys.indexOf(moduleName)>-1?false:true;
  }
}

interface breadModel {
  Label: string,
  Url: string
}